import { useEffect } from "preact/hooks";
import { activePage, activeSolution, headVersion, selectedVersion } from "./state/appState";
import { initRouter, navigateTo, PAGES } from "./router";
import { APP_CHANGELOG, APP_VERSION } from "./config";
import { SolutionSearch } from "./components/SolutionSearch";
import { DemandPage } from "./pages/DemandPage/DemandPage";
import { SsmPage } from "./pages/SsmPage/SsmPage";
import { KiosksPage } from "./pages/KiosksPage/KiosksPage";
import { VersionPanel } from "./pages/DemandPage/VersionPanel";

export function App() {
  useEffect(() => {
    initRouter();
  }, []);

  const solution = activeSolution.value;

  return (
    <div>
      <div id="page-header">
        <div id="header-left">
          <h1>PARSONII Solution Overview</h1>
          <div class="app-version-wrap">
            <span class="app-version">v{APP_VERSION}</span>
            {APP_CHANGELOG.length > 0 && (
              <div class="app-version-tooltip">
                {APP_CHANGELOG.map(({ version, items }) => (
                  <div key={version}>
                    <strong>v{version}:</strong>
                    <ul>
                      {items.map((item) => (
                        <li key={item}>{item}</li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            )}
          </div>
          <SolutionSearch />
        </div>
        {(headVersion.value || selectedVersion.value) && (
          <div id="header-panels">
            {headVersion.value && <VersionPanel title="New" data={headVersion.value} />}
            {selectedVersion.value && (
              <VersionPanel title="Selected" data={selectedVersion.value} diffAgainst={headVersion.value} selected />
            )}
          </div>
        )}
      </div>
      <nav class="tabs">
        {PAGES.map((page) => (
          <button
            key={page.id}
            class={activePage.value === page.id ? "active" : ""}
            onClick={() => navigateTo(page.id)}
          >
            {page.label}
          </button>
        ))}
      </nav>
      {activePage.value === "kiosks" && <KiosksPage />}
      {activePage.value === "demand" &&
        (solution ? (
          <DemandPage solution={solution} />
        ) : (
          <div class="status-banner">
            <p>Search for a solution to view demand.</p>
          </div>
        ))}
      {activePage.value === "ssm" &&
        (solution ? (
          <SsmPage solution={solution} />
        ) : (
          <div class="status-banner">
            <p>Search for a solution to view SSM parameters.</p>
          </div>
        ))}
    </div>
  );
}
